import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./Gallery.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { t } from "../../locales/i18n";
import Header from "../../components/Header/Header";
import { Helmet } from "react-helmet";
import BookNowBtn from "../../components/BookNowBtn";
import FooterInfo from "../../components/FooterInfo/FooterInfo";
import FloatingButton from "../../components/FloatingButton/FloatingButton";
import { ReactPhotoCollage } from "react-photo-collage";
import { images } from "../../assets/img";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

const Gallery = () => {
  const navigate = useNavigate();
  const isMobile = useCheckIsMobile();

  return (
    <div className={classes.container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"Gallery"}</title>
        <meta name="gallery" content="Gallery" />
      </Helmet>
      <Header selected={"gallery"} />

      <div className={classes.introTextContainer}>
          <div>
          <h1>{"WHERE BEAUTY MEET RELAXATION!"}</h1>
            <h3 className={classes.greyIntroTextContainer}>
            Healthy Nails, Happy You
            </h3>
          </div>
          <p className={classes.greyIntroTextContainer}>
          Step into REFINED BEAUTY NAILS — where elegance meets expertise. Our
            passionate team is here to turn your nail vision into reality,
            whether you love timeless classics or bold, custom designs. With a
            focus on quality, creativity, and care, every visit is a chance to
            relax, refresh, and leave feeling your absolute best.
          </p>
          <p className={classes.greyIntroTextContainer}>
          We blend skilled technique with thoughtful service to create
            stunning results tailored to your style. Whether you're after
            everyday elegance or something truly one-of-a-kind, we’re here to
            make your nails a work of art.
          </p>
        </div>

      <ReactPhotoCollage
        width={"100%"}
        height={
          isMobile
            ? ["30rem", "23rem", "35rem", "28rem"]
            : ["45rem", "30rem", "35rem"]
        }
        layout={isMobile ? [2, 1, 2, 3] : [2, 2, 4]}
        photos={[
          { source: images.nail3 },
          { source: images.nail1 },
          { source: images.nail2 },
          { source: images.nail5 },
          { source: images.nail6 },
          { source: images.nail3 },
          { source: images.nail4 },
          { source: images.nail11 },
        ]}
        showNumOfRemainingPhotos
      />
      <h1>Gift Voucher Available</h1>
      <BookNowBtn style={classes.bookNowBtnStyle} />

      <FooterInfo style={classes.footerStyle} />
      <FloatingButton />
    </div>
  );
};

export default Gallery;
